import { post, get } from "../utils/request"

export const noticeStatus = (data) => {
    return post("/ci-message/notice/disable", data)
}

export const noticeTemplateStatus = (data) => {
    return post("/ci-message/notice/disable_template", data)
}